module.exports = __webpack_public_path__ + "assets/img/teacher (21).ad2b46ff.png";